import React, { useState } from "react";
import CustomTab from "../../../components/common/CustomTab";

import SMSTab from "./SMSTab";
import EmailTab from "./EmailTab";
import WhatsAppTab from "./WhatsappTab";



const CommunicationTab = ({ providers, onStatusChange, onEdit, onDelete, onAdd }) => {
  // Separate providers by type
  const whatsappProviders = providers.filter(p => p.type === 'whatsapp');
  const smsProviders = providers.filter(p => p.type === 'sms');
  const emailProviders = providers.filter(p => p.type === 'email');

  const handleStatusChange = (type, id, newValue) => {
    onStatusChange(id, newValue);
  };

  const handleEdit = (provider) => {
    onEdit(provider);
  };

  const handleDelete = (type, provider) => {
    onDelete(provider);
  };

  const handleAdd = (type) => {
    onAdd(type);
  };

  const tabList = [
    {
      title: "What's App",
      component: <WhatsAppTab 
        providers={whatsappProviders}
        onStatusChange={(id, newValue) => handleStatusChange('whatsapp', id, newValue)}
        onEdit={handleEdit}
        onDelete={(provider) => handleDelete('whatsapp', provider)}
        onAdd={handleAdd}
      />
    },
    {
      title: "SMS",
      component: <SMSTab 
        providers={smsProviders}
        onStatusChange={(id, newValue) => handleStatusChange('sms', id, newValue)}
        onEdit={handleEdit}
        onDelete={(provider) => handleDelete('sms', provider)}
        onAdd={handleAdd}
      />
    },
    {
      title: "Email",
      component: <EmailTab 
        providers={emailProviders}
        onStatusChange={(id, newValue) => handleStatusChange('email', id, newValue)}
        onEdit={handleEdit}
        onDelete={(provider) => handleDelete('email', provider)}
        onAdd={handleAdd}
      />
    }
  ];

  return (
    <div className="bg-white rounded-lg p-4 border"><CustomTab
      tabList={tabList}
    /></div>
    
  );
};

export default CommunicationTab; 